export const EUFY_SECURITY_APPLICATION_NAME = 'eufy_security'
export const EUFY_LIFT_APPLICATION_NAME = 'eufy_life'
export const EUFY_HOME_APPLICATION_NAME = 'eufy_home'
export const EUFY_MEGA_APPLICATION_NAME = 'eufy_mega'
export const EUFY_SHOPIFY_APPLICATION_NAME = 'eufy_shopify'
export const EUFY_BABY_APPLICATION_NAME = 'eufy_baby'